export default "__VITE_ASSET__c0ac266e__"